<template>
  <!-- Modal template -->
  <admin-modal
    v-show="show"
    title="Add Stream"
    class="long"
    :error="error"
    :loading="loading"
    @cancel="closeModal"
  >
    <template v-slot:body>
      <!-- Stream parameters -->
      <div class="modal__row">
        <div class="modal__field long-field">
          <span class="modal__label">Stream URL</span>
          <input
            v-model="form.streamUrl"
            :class="{ error: !streamUrlValidStatus.valid }"
            class="modal__input"
          />
        </div>
      </div>

      <div class="modal__row">
        <div class="modal__field long-field">
          <span class="modal__label">Stream Name</span>
          <input
            v-model="form.streamName"
            :class="{ error: !streamNameValidStatus.valid }"
            class="modal__input"
          />
        </div>
      </div>

      <div class="modal__row">
        <div class="modal__field long-field">
          <span class="modal__label">Stream Type</span>
          <select v-model="form.channelType" class="modal__input">
            <option v-for="type in channelTypes" :key="type" :value="type">
              {{ type }}
            </option>
          </select>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <!-- Cancel button -->
      <div class="modal-btn cancel-btn" @click="closeModal">
        Cancel
      </div>
      <!-- Submit button -->
      <div class="modal-btn submit-btn" @click="trySubmit">
        Add
      </div>
    </template>
  </admin-modal>
</template>

<script>
import AdminModal from "@/components/admin/modals/AdminModal.vue";
import { CHANNEL_TYPE } from "@/constants.js";

// @group Dialog
// Modal for new stream creating
export default {
  name: "AddStreamModal",
  components: {
    AdminModal
  },
  props: {
    // is modal shown
    show: {
      type: Boolean,
      default: false
    },
    // is modal cleared, set 'true' to clear modal fields
    clear: {
      type: Boolean,
      default: true
    },
    // is modal loading
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /** Form data template */
      defaultForm: {
        streamName: "default",
        streamUrl: "https://test1.servers.ru/stream.m3u8",
        channelType: "video"
      },
      /** form data */
      form: {
        streamName: null,
        streamUrl: null
      }
    };
  },
  computed: {
    channelTypes() {
      return Object.values(CHANNEL_TYPE);
    },
    // @vuese
    // Is all form data valid
    isValid() {
      return (
        this.streamNameValidStatus.valid && this.streamUrlValidStatus.valid
      );
    },
    // @vuese
    // Error message or 'null' (if form is valid)
    error() {
      if (!this.streamNameValidStatus.valid) {
        return this.streamNameValidStatus.error;
      }

      if (!this.streamUrlValidStatus.valid) {
        return this.streamUrlValidStatus.error;
      }

      return null;
    },
    // @vuese
    // Is stream name valid
    streamNameValidStatus() {
      const name = this.form.streamName;

      if (!name || name.length == 0) {
        return {
          valid: false,
          error: "Stream name must not be empty"
        };
      }

      if (name.length > 30) {
        return {
          valid: false,
          error: "Maximum channel name length is 50"
        };
      }

      const re = /^[a-z0-9_]+$/i;

      if (!re.test(name)) {
        return {
          valid: false,
          error:
            "Stream short name must contain only alphanumeric, digits or underline."
        };
      }

      return {
        valid: true
      };
    },
    // @vuese
    // Is stream URL valid
    streamUrlValidStatus() {
      const url = this.form.streamUrl;

      try {
        new URL(url);
      } catch (err) {
        return {
          valid: false,
          error: "Stream URL must be a valid URL"
        };
      }

      return {
        valid: true
      };
    }
  },
  watch: {
    // Clear form
    clear() {
      this.clearForm();
    }
  },
  mounted() {
    this.clearForm();
  },
  methods: {
    // @vuese
    // Accept stream adding
    addStream() {
      // User try to add stream
      this.$emit("addStream", this.form);
    },
    // @vuese
    // Set default values to form data
    clearForm() {
      this.form = { ...this.defaultForm };
    },
    // @vuese
    // Emit 'addStream' event, if form is active
    trySubmit() {
      /** Errors and loading prevent to submit modal */
      if (this.isValid && !this.loading) {
        this.addStream();
      }
    },
    closeModal() {
      // User try to close modal
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modal-body {
  display: flex;
}

.modal__field.long-field {
  width: 100%;
}
</style>
